import { ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../../lib/cn';
import { Menu, MenuContent, MenuRadioGroup, MenuRadioItem, MenuTrigger } from '../../../ui/Menu';

export interface FilterOption {
  value: string;
  label: string;
  leading?: ReactNode;
}

/**
 * Filtr listy w ramce (Figma 07 Projekty: „Klient: wszyscy ⌄”): etykieta i wybrana wartość, menu z jedną opcją.
 * Pusta wartość (`''`) = „wszyscy”.
 */
export function FilterMenu({
  label,
  allLabel = 'wszyscy',
  value,
  onValueChange,
  options,
  className,
}: {
  label: string;
  allLabel?: string;
  value: string;
  onValueChange: (value: string) => void;
  options: FilterOption[];
  className?: string;
}) {
  const current = options.find((o) => o.value === value);
  return (
    <Menu>
      <MenuTrigger
        className={cn(
          'inline-flex h-9 max-w-[260px] shrink-0 items-center gap-1.5 rounded-lg border border-line bg-canvas pr-2.5 pl-3 text-body-s text-fg-secondary max-md:h-11',
          'transition-colors hover:border-line-strong hover:text-fg focus-visible:outline-2 focus-visible:outline-accent',
          'data-[state=open]:border-line-strong',
          // lifting 17.10.2026: aktywny filtr — tło i tekst akcentu (DESIGN „Lifting”)
          current && 'border-transparent bg-accent-subtle text-accent hover:border-transparent hover:text-accent',
          className,
        )}
      >
        <span className="truncate">
          {label}: {current ? current.label : allLabel}
        </span>
        <ChevronDown size={14} strokeWidth={1.75} aria-hidden className="shrink-0 text-fg-muted" />
      </MenuTrigger>
      <MenuContent align="end" className="max-h-80 overflow-y-auto">
        <MenuRadioGroup value={value} onValueChange={onValueChange}>
          <MenuRadioItem value="">{allLabel.charAt(0).toUpperCase() + allLabel.slice(1)}</MenuRadioItem>
          {options.map((o) => (
            <MenuRadioItem key={o.value} value={o.value}>
              <span className="flex items-center gap-2">
                {o.leading}
                <span className="truncate">{o.label}</span>
              </span>
            </MenuRadioItem>
          ))}
        </MenuRadioGroup>
      </MenuContent>
    </Menu>
  );
}
